<template>
  <footer class="st-Footer">
    <div class="st-Footer_Pagetop" @click="goTop"><i class="el-icon-arrow-up"></i></div>
    <div class="st-Footer_Inner">
      <nav class="st-FtDirectory">
        <div class="st-FtDirectory_Logo">
          <router-link to="/"><img class="logo-img-navbar-coypright" src="../../../static/img/logo/logo-white.png" alt=""></router-link>
        </div>
        <div class="st-FtDirectory_Column">
          <h3 class="st-FtDirectory_Column-title" style="width:200px">COMPANY<i></i></h3>
          <ul class="st-FtDirectory_Column-list">
            <li>
              <router-link to="/company/profile">企業情報</router-link>
            </li>
          </ul>
        </div>
        <div class="st-FtDirectory_Column">
          <h3 class="st-FtDirectory_Column-title" style="width:200px">SOLUTIONS<i></i></h3>
          <ul class="st-FtDirectory_Column-list">
            <li class="mb-md-0">
              <router-link to="/solution/logistics-automation">ロボティクス自動化ソリューション
              </router-link>
            </li>
            <li>
              <router-link to="/solution/low-code">Lowコードソリューション</router-link>
            </li>
          </ul>
        </div>
        <div class="st-FtDirectory_Column">
          <h3 class="st-FtDirectory_Column-title" style="width:200px">SERVICE<i></i></h3>
          <ul class="st-FtDirectory_Column-list">
            <li>
              <router-link to="/service/index">サービス案内</router-link>
            </li>
          </ul>
        </div>
        <div class="st-FtDirectory_Column">
          <h3 class="st-FtDirectory_Column-title" style="width:200px">RECRUIT<i></i></h3>
          <ul class="st-FtDirectory_Column-list">
            <li>
              <router-link to="/recruit/index">採用情報</router-link>
            </li>
          </ul>
        </div>
        <div class="st-FtDirectory_Column">
          <h3 class="st-FtDirectory_Column-title" style="width:200px">CONTACT US<i></i></h3>
          <ul class="st-FtDirectory_Column-list">
            <li>
              <router-link to="/contact/index">お問い合わせ</router-link>
            </li>
          </ul>
        </div>
      </nav>
      <div class="st-FtPress pt-3">
        <div class="sw-Section_HeaderS mb-0 copyright-news-appear-1" data-appear="true">
          <div class="st-Grid_Inner-copyright_news p-0">
            <div class="row col-12">
              <div style="width: 60px;">
                <p style="font-size: 2.2rem;"><img src="../../../static/img/home/sm.png" width="60" height="60" />
                </p>
              </div>
              <div class="col">
                <h2 class="mb-3 pt-4">
                  <span class="sw-Section_Header-en mb-3" style="font-size: 1.7rem;"><b>
                      <font>
                        <font>NEWS</font>
                      </font>
                    </b></span>
                  <span class="sw-Section_Header-ja" style="font-size: 1.3rem;"><b style="height: 20px;">
                      <font>
                        <font>お知らせ</font>
                      </font>
                    </b></span>
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div class="st-FtPress_Slide swiper-container mt-5 mt-md-5 mb-0">
          <div class="swiper-wrapper">
            <div v-for="(item, index) in newsList" :key="index" class="swiper-slide">
              <div v-if="item.title.length > 10" class="text-border-copyright-silde pb-2 mb-3 text-left" style="min-height:50px;font-size: 12px;padding-top: 5px;width: 170px;">
                <div class="pl-3">{{item.title}}</div>
              </div>
              <div v-else class="text-border-copyright-silde pb-2 mb-3 text-center" style="min-height:50px;font-size: 12px;padding-top: 13px;">
                {{item.title}}
              </div>
              <a @click="goNewsDetail(item.newsId)">
                <img :src="'../../../static/img/news/'+item.imgSrc">
                <p class="vol mt-3" style="font-size: 12px;">{{item.date}}</p>
                <!-- <p class="title" style="font-size: 12px;" :style="onChangeFontSize(item.content1.length)">{{item.content1}}</p> -->
              </a>
            </div>
          </div>
        </div>
        <div class="st-FtPress_Slide-scrollbar">
        </div>
      </div>
    </div>

    <div class="st-FtLegal pt-5">
      <div class="st-FtLegal_Inner">

        <div class="st-FtLegal_Right">
          <ul class="st-FtLegal_Link">
            <li>
              <router-link to="/policy">サイトポリシー</router-link>
            </li>
            <li>
              <router-link to="/privacy">プライバシーポリシー</router-link>
            </li>
          </ul>
          <p style="margin-bottom: 0rem;" class="st-FtLegal_Copyright pb-5 pb-md-0"><small>&copy; 株式会社ロボティクスソリューションズ All Rights Reserved.</small></p>
        </div>
      </div>
    </div>
  </footer>
</template>

<style />

<script type="text/javascript">

import Swiper from 'swiper/swiper-bundle.js'
import 'swiper/swiper-bundle.css'
import newsList from '../../../static/js/news-list.js'

export default {
  inject: ["reload"],
  data: function () {
    return {
      stFtPressSwiper: '',
      newsList: newsList
    }
  },
  mounted() {
    let stFtPressSwiperSettings = {
      initialSlide: 1,
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      effect: 'coverflow',
      scrollbar: {
        el: '.st-FtPress_Slide-scrollbar',
        draggable: true,
        snapOnRelease: true
      }

    }
    this.stFtPressSwiper = new Swiper('.st-FtPress_Slide', stFtPressSwiperSettings)

    $('.st-FtDirectory_Column-title').on('click', function () {
      if (!$(this).hasClass('no-slide')) {
        $(this).toggleClass('is-open')
        $(this).next('.st-FtDirectory_Column-list').slideToggle(300)
      }
    })

    let beforeScollH = 0
    $(document).scroll(() => {

      let scroH = $(document).scrollTop()
      let viewW = $(window).width()
      let differH = scroH - beforeScollH
      let mql = window.matchMedia('(max-width:768px)')

      let scrollHeight = document.body.scrollHeight
      if (differH === 0) {
        return false
      }
      beforeScollH = scroH

      if (viewW > 769) {
        if (scroH > scrollHeight - 1600) {
          $('.st-Grid_Inner-copyright_news').eq(0).addClass('st-Grid_Inner-copyright_news_appear')
          $('.copyright-news-appear-1').addClass('appear')
          $('.copyright-news-appear-1').parent().addClass('st-Grid_Inner_appear')
        } else {
          $('.st-Grid_Inner-copyright_news').eq(0).removeClass('st-Grid_Inner-copyright_news_appear')
          $('.copyright-news-appear-1').removeClass('appear')
          $('.copyright-news-appear-1').parent().removeClass('st-Grid_Inner_appear')
        }
      } else {
        $('.st-Grid_Inner-copyright_news').eq(0).addClass('st-Grid_Inner-copyright_news_appear')
        $('.copyright-news-appear-1').addClass('appear')
        $('.copyright-news-appear-1').parent().addClass('st-Grid_Inner_appear')
      }
    })

  },
  methods: {
    onChangeFontSize(length) {
      // if (length > 18) {
      //   return 'font-size:1.25rem'
      // } else if (length > 16) {
      //   return 'font-size:1.4rem'
      // } else if (length > 15) {
      //   return 'font-size:1.5rem'
      // }
    },
    goNewsDetail(newsId) {
      this.reload();
      this.$router.push({
        path: '/news/news-detail',
        query: { newsId: newsId }
      }).catch(err => { window.scrollTo(0, 0); })
    },
    goTop() {
      $(document.documentElement).animate({
        scrollTop: 0
      }, 300)
    }
  }
}
</script>
<style scoped>
@import url(../../../static/css/copyright.css);
.text-border-copyright-silde {
  border: 1px #fff solid;
  border-radius: 3px;
}

@media screen and (min-width: 769px) {
  .st-FtLegal_Sites:not(:last-child):after {
    content: "";
    width: 1px;
    height: 175px;
    background-color: #4d4d4d;
    position: absolute;
    right: 0;
    bottom: 0;
  }
}

.st-FtLegal {
  background-color: #121212;
}

.st-Footer {
  padding: 40px 0 0;
}

@media screen and (min-width: 769px) {
  .st-Footer {
    padding: 80px 0 0;
  }
}

.st-FtLegal_Sites-link a[target="_blank"]:after {
  color: #fff;
  font-size: 0rem;
  line-height: 1em;
  letter-spacing: 0;
  padding-left: 6px;
  vertical-align: baseline;
}

.st-FtLegal_Link a:hover {
  color: #fff;
  text-decoration: none;
}

.st-FtLegal_Sites-link a:hover {
  color: #fff;
  text-decoration: none;
}

.st-FtPress_Logo a:after {
  font-size: 0rem;
}

.st-FtPress_Slide >>> .swiper-slide {
  width: 146.316px !important;
}

.st-FtPress_Slide >>> img {
  object-fit: cover;
  height: 196.316px !important;
}

a {
  border-bottom-style: none;
}

.el-icon-arrow-up {
  font-size: 15px;
  margin-left: 14px;
  margin-top: 13px;
  font-weight: bold;
}

@media screen and (min-width: 769px) {
  .el-icon-arrow-up {
    font-size: 25px;
    margin-left: 15px;
    margin-top: 13px;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/copyright.vue